import { CategoryItemWrapper } from "../../../../services/context/CategoryItemContext";
import { useGuestBuiltLoyaltyOffers } from "../../../../services/hooks/loyalty/useGuestBuiltLoyaltyOffers";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { cn } from "../../../../utils/cn";
import { LoyaltyOfferIcon } from "../../../global/LoyaltyOfferIcon/LoyaltyOfferIcon";
import { CategoryItemCardV2 } from "../CategoryItemList/CategoryItem/CategoryItemCardNew/CategoryItemCardV2";
import categoryStyles from "../CategoryItemList/CategoryListV2.module.scss";
import styles from "./SpeciallyForYouSection.module.scss";

export const SPECIALLY_FOR_YOU_ANCHOR = "specially_for_you";

/** Offer cards have no menu item to add; the card routes to the offer page. */
const noop = () => {};

type SpeciallyForYouSectionProps = {
  isListView: boolean;
};

/**
 * Menu entry point for guest-built offers, laid out as an ordinary category so
 * grid and list mode need no special casing. Renders nothing when the guest
 * has none applicable, so the section never appears empty.
 */
export const SpeciallyForYouSection = ({
  isListView,
}: SpeciallyForYouSectionProps) => {
  const { t } = useTranslationI18();
  const offers = useGuestBuiltLoyaltyOffers();

  if (!offers.length) {
    return null;
  }

  return (
    <div
      className={categoryStyles.category_section}
      id={`category_${SPECIALLY_FOR_YOU_ANCHOR}`}
      data-testid="specially-for-you"
    >
      <h4 className={cn(categoryStyles.category_title, styles.heading)}>
        <span className={styles.heading_icon} aria-hidden="true">
          <LoyaltyOfferIcon
            offer={offers[0]}
            giftIcon
            iconOnly
            backgroundIconColor="loyalty"
            width={24}
          />
        </span>
        {t("offers:specially-for-you")}
      </h4>

      <div
        className={
          isListView
            ? categoryStyles.items_container_list
            : categoryStyles.items_container_grid
        }
        data-testid={
          isListView ? "items-container-list" : "items-container-grid"
        }
      >
        {offers.map((offer, index) => (
          <div
            key={offer.id}
            className={
              isListView ? categoryStyles.list_item_wrapper : undefined
            }
          >
            <CategoryItemWrapper
              offer={offer}
              index={index}
              categoryId={0}
              addItem={noop}
              logoUrl=""
              isMenuView={!isListView}
            >
              <CategoryItemCardV2 />
            </CategoryItemWrapper>
          </div>
        ))}
      </div>
    </div>
  );
};
